import { ConnectionStatus } from "app/webSockets/channels"
import { PlanningTimeslotsChannelPayload } from "./planningTimeslotsChannel.reducer"

export enum Types {
  CONNECT = "TIMESLOTSCHANNEL_CONNECT",
  CONNECTION_SUCCESS = "TIMESLOTSCHANNEL_CONNECTION_SUCCESS",
  CONNECTION_FAILED = "TIMESLOTSCHANNEL_CONNECTION_FAILED",
  DISCONNECT = "TIMESLOTSCHANNEL_DISCONNECT",
  DISCONNECT_SUCCESS = "TIMESLOTSCHANNEL_DISCONNECT_SUCCESS",
  DISCONNECT_FAILED = "TIMESLOTSCHANNEL_DISCONNECT_FAILED",
  STATUS = "TIMESLOTSCHANNEL_STATUS",
}

export type Action =
  | ConnectTimeslotsChannelAction
  | ConnectionTimeslotsChannelSuccessAction
  | ConnectionTimeslotsChannelFailAction
  | DisconnectTimeslotsChannelAction
  | DisconnectTimeslotsChannelSuccessAction
  | DisconnectTimeslotsChannelFailAction
  | ConnectionTimeslotsChannelStatusAction

export type ConnectTimeslotsChannelAction = {
  payload: PlanningTimeslotsChannelPayload
  type: Types.CONNECT
}

export type ConnectionTimeslotsChannelSuccessAction = {
  type: Types.CONNECTION_SUCCESS
}

export type ConnectionTimeslotsChannelFailAction = {
  payload: { errors: object }
  type: Types.CONNECTION_FAILED
}

export type DisconnectTimeslotsChannelAction = {
  type: Types.DISCONNECT
}

export type DisconnectTimeslotsChannelSuccessAction = {
  type: Types.DISCONNECT_SUCCESS
}

export type DisconnectTimeslotsChannelFailAction = {
  payload: { errors: object }
  type: Types.DISCONNECT_FAILED
}

export type ConnectionTimeslotsChannelStatusAction = {
  payload: ConnectionStatus
  type: Types.STATUS
}

export function connectTimeslotsChannel(payload: PlanningTimeslotsChannelPayload): ConnectTimeslotsChannelAction {
  return {
    payload,
    type: Types.CONNECT,
  }
}

export function connectionTimeslotsChannelSuccess(): ConnectionTimeslotsChannelSuccessAction {
  return {
    type: Types.CONNECTION_SUCCESS,
  }
}

export function connectionTimeslotsChannelFail(errors: object): ConnectionTimeslotsChannelFailAction {
  return {
    payload: { errors },
    type: Types.CONNECTION_FAILED,
  }
}

export function disconnectTimeslotsChannel(): DisconnectTimeslotsChannelAction {
  return {
    type: Types.DISCONNECT,
  }
}

export function disconnectTimeslotsChannelSuccess(): DisconnectTimeslotsChannelSuccessAction {
  return {
    type: Types.DISCONNECT_SUCCESS,
  }
}

export function disconnectTimeslotsChannelFail(errors: object): DisconnectTimeslotsChannelFailAction {
  return {
    payload: { errors },
    type: Types.DISCONNECT_FAILED,
  }
}

export function connectionTimeslotsChannelStatus(status: ConnectionStatus): ConnectionTimeslotsChannelStatusAction {
  return {
    payload: status,
    type: Types.STATUS,
  }
}
